//admin-ws.js
import { HttpMethod } from 'app/utils/network';
import { API } from 'app/utils/request';

export const addAdmin = (adminRequest) => {
  const urlPath = '/admin/addAdmin';
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: adminRequest
  });
};

export const updateAdminDetails = (adminRequest) => {
  const urlPath = '/admin/updateAdmin';
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: adminRequest
  });
};

export const getAllAdminDetails = () => {
  const urlPath = '/admin/getAllAdminDetails';
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath

    // Authorization: `Bearer ${authToken}`,
  });
};
export const getSelectedAdminDetails = (adminId, authToken) => {
  const urlPath = `/admin/getadminDetails/${adminId}`;
  const additionalHeader = {
    Authorization: `Bearer ${authToken}`
  };
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
    // Authorization: `Bearer ${authToken}`,
  });
};
